module.exports = __webpack_public_path__ + "img/310.634ba80f.png";